module.exports = __webpack_public_path__ + "media/bootstrap-icons/skip-start-af152ae5.svg";